import React from 'react';

const PageBody = (props) => (
    <div className="bottom dashboard-content-background">
        {props.children}
    </div>
);

export default PageBody